import { ComponentType } from "react";
import { MDSIconKind } from "@/mds/components/icon/icon/icon.types";

import * as ProLightSvgIcons from "@fortawesome/pro-light-svg-icons";
import * as ProRegularSvgIcons from "@fortawesome/pro-regular-svg-icons";
import * as ProSolidSvgIcons from "@fortawesome/pro-solid-svg-icons";
import * as ProDuotoneSvgIcons from "@fortawesome/pro-duotone-svg-icons";
import * as FreeBrandsSvgIcons from "@fortawesome/free-brands-svg-icons";

import CloudSlashFlippedIcon from "@/assets/images/cloud-slash-flipped.svg?react";
import CodeBlockIcon from "@/assets/images/code-block.svg?react";
import ZapierLogoIcon from "@/assets/icons/brands/zapier.svg?react";
import ZapierLogoSquareIcon from "@/assets/icons/brands/zapier-square.svg?react";
import FirefliesLogoIcon from "@/assets/icons/brands/fireflies.svg?react";
import TypeformLogoIcon from "@/assets/icons/brands/typeform.svg?react";
import SkipForwardIcon from "@/assets/icons/other/skip-forward.svg?react";
import SkipBackwardIcon from "@/assets/icons/other/skip-backward.svg?react";
import CleanupIcon from "@/assets/icons/other/clean-up.svg?react";
import VoiceModeIcon from "@/assets/icons/other/voice-mode.svg?react";
import AutoOrganizeIcon from "@/assets/icons/other/auto-organize.svg?react";
import BrandIcon from "@/assets/icons/brands/mem-up.svg?react";
import BrandHoverIcon from "@/assets/icons/brands/mem-up-hover.svg?react";
import BrandDisabledIcon from "@/assets/icons/brands/mem-up-disabled.svg?react";
import LogoIcon from "@/assets/icons/brands/mem-logo.svg?react";
import GoogleChromeIcon from "@/assets/icons/brands/google-chrome.svg?react";
import ArrowBrandIcon from "@/assets/icons/other/arrow-brand.svg?react";
import FindIcon from "@/assets/icons/other/find.svg?react";
import RadarIcon from "@/assets/icons/other/radar.svg?react";
import GoogleCalendarIcon from "@/assets/icons/other/google-calendar.svg?react";
import OutlookCalendarIcon from "@/assets/icons/other/outlook-calendar.svg?react";

export const fontAwesomeIconMapping: {
  [key in MDSIconKind]: ProRegularSvgIcons.IconDefinition;
} = {
  [MDSIconKind.AlignLeft]: ProRegularSvgIcons.faAlignLeft,
  [MDSIconKind.ArrowLeftToLine]: ProRegularSvgIcons.faArrowLeftToLine,
  [MDSIconKind.ArrowDownToLine]: ProRegularSvgIcons.faArrowDownToLine,
  [MDSIconKind.ArrowRightToLine]: ProRegularSvgIcons.faArrowRightToLine,
  [MDSIconKind.ArrowUpToLine]: ProSolidSvgIcons.faArrowUpToLine,
  [MDSIconKind.ArrowUpFromLine]: ProRegularSvgIcons.faArrowUpFromLine,
  [MDSIconKind.ArrowFromRight]: ProRegularSvgIcons.faChevronDoubleLeft,
  [MDSIconKind.ArrowToRight]: ProRegularSvgIcons.faChevronDoubleRight,
  [MDSIconKind.ArrowUpRight]: ProRegularSvgIcons.faArrowUpRight,
  [MDSIconKind.ArrowUpRightFromSquare]: ProRegularSvgIcons.faArrowUpRightFromSquare,
  [MDSIconKind.ArrowUpArrowDown]: ProRegularSvgIcons.faArrowUpArrowDown,
  [MDSIconKind.ArrowDownTurnLeft]: ProRegularSvgIcons.faArrowRightToArc,
  [MDSIconKind.ArrowRightFromLine]: ProRegularSvgIcons.faArrowRightFromLine,
  [MDSIconKind.ArrowUp]: ProRegularSvgIcons.faArrowUp,
  [MDSIconKind.Expand]: ProRegularSvgIcons.faArrowUpRightAndArrowDownLeftFromCenter,
  [MDSIconKind.Collapse]: ProRegularSvgIcons.faArrowDownLeftAndArrowUpRightToCenter,
  [MDSIconKind.Play]: ProRegularSvgIcons.faPlay,
  [MDSIconKind.Eye]: ProRegularSvgIcons.faEye,
  [MDSIconKind.EyeSlash]: ProRegularSvgIcons.faEyeSlash,
  [MDSIconKind.Home]: ProRegularSvgIcons.faHomeLgAlt,
  [MDSIconKind.Group]: ProRegularSvgIcons.faUsers,
  [MDSIconKind.Rocket]: ProRegularSvgIcons.faRocket,
  [MDSIconKind.Flows]: ProRegularSvgIcons.faWater,
  [MDSIconKind.Star]: ProRegularSvgIcons.faStar,
  [MDSIconKind.StarSolid]: ProSolidSvgIcons.faStar,
  [MDSIconKind.Tag]: ProRegularSvgIcons.faHashtag,
  [MDSIconKind.Tasks]: ProRegularSvgIcons.faTasks,
  [MDSIconKind.List]: ProRegularSvgIcons.faList,
  [MDSIconKind.ListCheck]: ProRegularSvgIcons.faListCheck,
  [MDSIconKind.BellSlash]: ProRegularSvgIcons.faBellSlash,
  [MDSIconKind.Cells]: ProRegularSvgIcons.faDiagramCells,
  [MDSIconKind.Checkbox]: ProRegularSvgIcons.faCheckSquare,
  [MDSIconKind.CheckboxSolid]: ProSolidSvgIcons.faCheckSquare,
  [MDSIconKind.CheckboxIndeterminate]: ProSolidSvgIcons.faSquareMinus,
  [MDSIconKind.Check]: ProRegularSvgIcons.faCheck,
  [MDSIconKind.CheckCircleSolid]: ProSolidSvgIcons.faCheckCircle,
  [MDSIconKind.CircleSolid]: ProSolidSvgIcons.faCircle,
  [MDSIconKind.CheckboxEmpty]: ProRegularSvgIcons.faSquare,
  [MDSIconKind.Square]: ProRegularSvgIcons.faSquare,
  [MDSIconKind.Circle]: ProRegularSvgIcons.faCircle,
  [MDSIconKind.Clock]: ProRegularSvgIcons.faClock,
  [MDSIconKind.Copy]: ProRegularSvgIcons.faCopy,
  [MDSIconKind.EmptyDocument]: ProRegularSvgIcons.faFile,
  [MDSIconKind.Document]: ProRegularSvgIcons.faFileAlt,
  [MDSIconKind.Envelope]: ProRegularSvgIcons.faEnvelope,
  [MDSIconKind.EnvelopeOpen]: ProRegularSvgIcons.faEnvelopeOpen,
  [MDSIconKind.Envelopes]: ProRegularSvgIcons.faEnvelopes,
  [MDSIconKind.Export]: ProRegularSvgIcons.faArrowDownToLine,
  [MDSIconKind.HandPointRibbon]: ProRegularSvgIcons.faHandPointRibbon,
  [MDSIconKind.Scribble]: ProRegularSvgIcons.faSignature,
  [MDSIconKind.Globe]: ProRegularSvgIcons.faGlobe,
  [MDSIconKind.Grip]: ProRegularSvgIcons.faGripDotsVertical,
  [MDSIconKind.Timeline]: ProRegularSvgIcons.faStream,
  [MDSIconKind.Icons]: ProRegularSvgIcons.faIcons,
  [MDSIconKind.Inbox]: ProRegularSvgIcons.faInbox,
  [MDSIconKind.Trash]: ProRegularSvgIcons.faTrash,
  [MDSIconKind.Settings]: ProRegularSvgIcons.faCog,
  [MDSIconKind.AddPerson]: ProRegularSvgIcons.faUserPlus,
  [MDSIconKind.LogOut]: ProRegularSvgIcons.faSignOut,
  [MDSIconKind.DesktopApp]: ProRegularSvgIcons.faSignOut,
  [MDSIconKind.BrandApple]: FreeBrandsSvgIcons.faApple,
  [MDSIconKind.BrandWindows]: FreeBrandsSvgIcons.faWindows,
  [MDSIconKind.PinRight]: ProRegularSvgIcons.faArrowFromRight,
  [MDSIconKind.UnpinRight]: ProRegularSvgIcons.faArrowToRight,
  [MDSIconKind.LeftArrow]: ProRegularSvgIcons.faArrowLeft,
  [MDSIconKind.RightArrow]: ProRegularSvgIcons.faArrowRight,
  [MDSIconKind.Calendar]: ProRegularSvgIcons.faCalendar,
  [MDSIconKind.Clear]: ProRegularSvgIcons.faTimesCircle,
  [MDSIconKind.Compose]: ProRegularSvgIcons.faPen,
  [MDSIconKind.ComposeAlt]: ProRegularSvgIcons.faPenAlt,
  [MDSIconKind.ComposeInline]: ProRegularSvgIcons.faPenToSquare,
  [MDSIconKind.Message]: ProRegularSvgIcons.faMessage,
  [MDSIconKind.MessageSolid]: ProSolidSvgIcons.faMessage,
  [MDSIconKind.MessageExclamation]: ProRegularSvgIcons.faMessageExclamation,
  [MDSIconKind.Search]: ProRegularSvgIcons.faSearch,
  [MDSIconKind.DropdownOpened]: ProRegularSvgIcons.faChevronUp,
  [MDSIconKind.DropdownClosed]: ProRegularSvgIcons.faChevronDown,
  [MDSIconKind.Exit]: ProRegularSvgIcons.faTimes,
  [MDSIconKind.WindowMinimize]: ProRegularSvgIcons.faWindowMinimize,
  [MDSIconKind.BoxFull]: ProLightSvgIcons.faBoxFull,
  [MDSIconKind.AngleRight]: ProRegularSvgIcons.faAngleRight,
  [MDSIconKind.AngleLeft]: ProRegularSvgIcons.faAngleLeft,
  [MDSIconKind.AngleUp]: ProRegularSvgIcons.faAngleUp,
  [MDSIconKind.AngleDown]: ProRegularSvgIcons.faAngleDown,
  [MDSIconKind.AngleRightSolid]: ProSolidSvgIcons.faAngleRight,
  [MDSIconKind.AngleLeftSolid]: ProSolidSvgIcons.faAngleLeft,
  [MDSIconKind.AngleUpSolid]: ProSolidSvgIcons.faAngleUp,
  [MDSIconKind.AngleDownSolid]: ProSolidSvgIcons.faAngleDown,
  [MDSIconKind.Crown]: ProRegularSvgIcons.faCrown,
  [MDSIconKind.Collection]: ProRegularSvgIcons.faHashtag,
  [MDSIconKind.More]: ProRegularSvgIcons.faEllipsisH,
  [MDSIconKind.Merge]: ProRegularSvgIcons.faMerge,
  [MDSIconKind.Minus]: ProRegularSvgIcons.faMinus,
  [MDSIconKind.Plus]: ProRegularSvgIcons.faPlus,
  [MDSIconKind.Reply]: ProRegularSvgIcons.faReply,
  [MDSIconKind.Share]: ProRegularSvgIcons.faShare,
  [MDSIconKind.Shared]: ProRegularSvgIcons.faUserFriends,
  [MDSIconKind.Sidebar]: ProRegularSvgIcons.faSidebarFlip,
  [MDSIconKind.Sparkle]: ProSolidSvgIcons.faSparkles,
  [MDSIconKind.SparkleOutline]: ProRegularSvgIcons.faSparkles,
  [MDSIconKind.UniqueSparkle]: ProSolidSvgIcons.faSparkle,
  [MDSIconKind.Cleanup]: ProSolidSvgIcons.faSparkles,
  [MDSIconKind.Bolt]: ProSolidSvgIcons.faBolt,
  [MDSIconKind.Upvote]: ProRegularSvgIcons.faThumbsUp,
  [MDSIconKind.Downvote]: ProRegularSvgIcons.faThumbsDown,
  [MDSIconKind.UpvoteSolid]: ProSolidSvgIcons.faThumbsUp,
  [MDSIconKind.DownvoteSolid]: ProSolidSvgIcons.faThumbsDown,
  [MDSIconKind.Send]: ProSolidSvgIcons.faPaperPlaneTop,
  [MDSIconKind.SendAlt]: ProRegularSvgIcons.faPaperPlaneTop,
  [MDSIconKind.Wifi]: ProRegularSvgIcons.faWifi,
  [MDSIconKind.WifiSlash]: ProRegularSvgIcons.faWifiSlash,
  [MDSIconKind.CloudSlash]: ProRegularSvgIcons.faCloudSlash,
  [MDSIconKind.LinkSolid]: ProSolidSvgIcons.faLinkSimple,
  [MDSIconKind.Link]: ProRegularSvgIcons.faLinkSimple,
  [MDSIconKind.Loader]: ProDuotoneSvgIcons.faLoader,
  [MDSIconKind.Lock]: ProRegularSvgIcons.faLock,
  [MDSIconKind.LockSolid]: ProSolidSvgIcons.faLock,
  [MDSIconKind.Bookmark]: ProRegularSvgIcons.faBookmark,
  [MDSIconKind.BookmarkSolid]: ProSolidSvgIcons.faBookmark,
  [MDSIconKind.Redo]: ProRegularSvgIcons.faRedo,
  [MDSIconKind.Menu]: ProRegularSvgIcons.faBars,
  [MDSIconKind.Book]: ProRegularSvgIcons.faBook,
  [MDSIconKind.Warning]: ProRegularSvgIcons.faWarning,
  [MDSIconKind.Experimental]: ProRegularSvgIcons.faFlask,
  [MDSIconKind.Sort]: ProRegularSvgIcons.faSort,
  [MDSIconKind.SortAlt]: ProRegularSvgIcons.faSortAlt,
  [MDSIconKind.Help]: ProRegularSvgIcons.faQuestionCircle,
  [MDSIconKind.Question]: ProRegularSvgIcons.faQuestion,
  [MDSIconKind.Sorted]: ProRegularSvgIcons.faBarsSort,
  [MDSIconKind.Spinner]: ProRegularSvgIcons.faSpinner,
  [MDSIconKind.SpinnerSolid]: ProSolidSvgIcons.faSpinner,
  [MDSIconKind.SpinnerThird]: ProDuotoneSvgIcons.faSpinnerThird,
  [MDSIconKind.Exclamation]: ProRegularSvgIcons.faExclamationCircle,
  [MDSIconKind.ExclamationSolid]: ProSolidSvgIcons.faExclamationCircle,
  [MDSIconKind.Danger]: ProSolidSvgIcons.faExclamationCircle,
  [MDSIconKind.Pen]: ProRegularSvgIcons.faPen,
  [MDSIconKind.Ban]: ProRegularSvgIcons.faBan,
  [MDSIconKind.Shapes]: ProRegularSvgIcons.faShapes,
  [MDSIconKind.User]: ProRegularSvgIcons.faUser,
  [MDSIconKind.UserSolid]: ProSolidSvgIcons.faUser,
  [MDSIconKind.Image]: ProRegularSvgIcons.faImage,
  [MDSIconKind.Gif]: ProRegularSvgIcons.faGif,
  [MDSIconKind.Film]: ProRegularSvgIcons.faFilm,
  [MDSIconKind.Code]: ProRegularSvgIcons.faCode,
  [MDSIconKind.Quote]: ProRegularSvgIcons.faQuoteLeft,
  [MDSIconKind.QuoteRight]: ProRegularSvgIcons.faQuoteRight,
  [MDSIconKind.Pdf]: ProRegularSvgIcons.faFilePdf,
  [MDSIconKind.PhoneSms]: ProRegularSvgIcons.faMobileButton,
  [MDSIconKind.Phone]: ProRegularSvgIcons.faPhone,
  [MDSIconKind.Import]: ProRegularSvgIcons.faArrowDownToSquare,
  [MDSIconKind.H1]: ProRegularSvgIcons.faH1,
  [MDSIconKind.H2]: ProRegularSvgIcons.faH2,
  [MDSIconKind.H3]: ProRegularSvgIcons.faH3,
  [MDSIconKind.Bold]: ProSolidSvgIcons.faBold,
  [MDSIconKind.Italic]: ProRegularSvgIcons.faItalic,
  [MDSIconKind.Underline]: ProRegularSvgIcons.faUnderline,
  [MDSIconKind.Strikethrough]: ProRegularSvgIcons.faStrikethrough,
  [MDSIconKind.NumberedList]: ProRegularSvgIcons.faListOl,
  [MDSIconKind.RemoveFormat]: ProRegularSvgIcons.faRemoveFormat,
  [MDSIconKind.Table]: ProRegularSvgIcons.faTable,
  [MDSIconKind.Paperclip]: ProRegularSvgIcons.faPaperclip,
  [MDSIconKind.Dot]: ProSolidSvgIcons.faCircleSmall,
  [MDSIconKind.Pipe]: ProRegularSvgIcons.faPipe,
  [MDSIconKind.InfoCircle]: ProRegularSvgIcons.faInfoCircle,
  [MDSIconKind.Notebook]: ProRegularSvgIcons.faNotebook,
  [MDSIconKind.Thumbtack]: ProRegularSvgIcons.faThumbtack,
  [MDSIconKind.ThumbtackSolid]: ProSolidSvgIcons.faThumbTack,
  [MDSIconKind.Heart]: ProRegularSvgIcons.faHeart,
  [MDSIconKind.HeartSolid]: ProSolidSvgIcons.faHeart,
  [MDSIconKind.GearCode]: ProRegularSvgIcons.faGearCode,
  [MDSIconKind.Compass]: ProRegularSvgIcons.faCompass,
  [MDSIconKind.CalendarDay]: ProRegularSvgIcons.faCalendarDay,
  [MDSIconKind.HorizontalRule]: ProRegularSvgIcons.faHorizontalRule,
  [MDSIconKind.Radar]: ProRegularSvgIcons.faRadar,
  [MDSIconKind.Robot]: ProRegularSvgIcons.faRobot,
  [MDSIconKind.Laptop]: ProRegularSvgIcons.faLaptop,
  [MDSIconKind.Mobile]: ProRegularSvgIcons.faMobileButton,
  [MDSIconKind.CloudArrowDown]: ProRegularSvgIcons.faCloudArrowDown,
  [MDSIconKind.CloudArrowUp]: ProRegularSvgIcons.faCloudArrowUp,
  [MDSIconKind.CloudArrowDownSolid]: ProSolidSvgIcons.faCloudArrowDown,
  [MDSIconKind.CloudArrowUpSolid]: ProSolidSvgIcons.faCloudArrowUp,
  [MDSIconKind.CloudExclamation]: ProRegularSvgIcons.faCloudExclamation,
  [MDSIconKind.CloudExclamationSolid]: ProSolidSvgIcons.faCloudExclamation,
  [MDSIconKind.Template]: ProRegularSvgIcons.faAlignLeft,
  [MDSIconKind.History]: ProRegularSvgIcons.faClockRotateLeft,
  [MDSIconKind.Filter]: ProRegularSvgIcons.faBarsFilter,
  [MDSIconKind.BoltOutline]: ProRegularSvgIcons.faBolt,
  [MDSIconKind.RegularMicrophone]: ProRegularSvgIcons.faMicrophone,
  [MDSIconKind.Microphone]: ProRegularSvgIcons.faMicrophone,
  [MDSIconKind.MicrophoneAlt]: ProRegularSvgIcons.faMicrophoneAlt,
  [MDSIconKind.MicrophoneSlash]: ProRegularSvgIcons.faMicrophoneSlash,
  [MDSIconKind.TextSlash]: ProRegularSvgIcons.faTextSlash,
  [MDSIconKind.Comment]: ProRegularSvgIcons.faComment,
  [MDSIconKind.Folder]: ProRegularSvgIcons.faFolder,
  [MDSIconKind.Clipboard]: ProRegularSvgIcons.faClipboard,
  [MDSIconKind.File]: ProRegularSvgIcons.faFile,
  [MDSIconKind.Waveform]: ProRegularSvgIcons.faWaveform,
  [MDSIconKind.WaveformLines]: ProRegularSvgIcons.faWaveformLines,
  [MDSIconKind.Video]: ProRegularSvgIcons.faVideo,
  [MDSIconKind.PlaySolid]: ProSolidSvgIcons.faPlay,
  [MDSIconKind.Pause]: ProRegularSvgIcons.faPause,
  [MDSIconKind.PauseSolid]: ProSolidSvgIcons.faPause,
  [MDSIconKind.ExternalLink]: ProRegularSvgIcons.faExternalLink,
  [MDSIconKind.Chrome]: FreeBrandsSvgIcons.faChrome,
  [MDSIconKind.RotateRight]: ProSolidSvgIcons.faRotateRight,
  [MDSIconKind.Moon]: ProRegularSvgIcons.faMoon,
  [MDSIconKind.Telescope]: ProRegularSvgIcons.faTelescope,
  [MDSIconKind.CopySolid]: ProSolidSvgIcons.faCopy,
  [MDSIconKind.Refresh]: ProRegularSvgIcons.faRefresh,
  [MDSIconKind.CalendarEvent]: ProRegularSvgIcons.faCalendarLinesPen,
  [MDSIconKind.CalendarCheck]: ProRegularSvgIcons.faCalendarCheck,
  /**
   * These are "custom icons" which are overwritten by images in MDSIcon.
   * The fallbacks are declared below.
   */
  [MDSIconKind.CloudSlashFlipped]: ProRegularSvgIcons.faCloudSlash,
  [MDSIconKind.CodeBlock]: ProRegularSvgIcons.faCode,
  [MDSIconKind.LogoFireflies]: ProRegularSvgIcons.faBriefcase,
  [MDSIconKind.LogoZapier]: ProRegularSvgIcons.faBriefcase,
  [MDSIconKind.LogoZapierSquare]: ProRegularSvgIcons.faBriefcase,
  [MDSIconKind.LogoTypeform]: ProRegularSvgIcons.faBriefcase,
  [MDSIconKind.Window]: ProRegularSvgIcons.faWindow,
  [MDSIconKind.Flask]: ProRegularSvgIcons.faFlask,
  [MDSIconKind.CircleMinus]: ProRegularSvgIcons.faCircleMinus,
  [MDSIconKind.CircleX]: ProSolidSvgIcons.faCircleX,
  [MDSIconKind.CircleExclamation]: ProSolidSvgIcons.faCircleExclamation,
  [MDSIconKind.SkipForward]: ProRegularSvgIcons.faForwardStep,
  [MDSIconKind.SkipBackward]: ProRegularSvgIcons.faBackwardStep,
  [MDSIconKind.SplitPanel]: ProRegularSvgIcons.faTableColumns,
  [MDSIconKind.PuzzlePiece]: ProRegularSvgIcons.faPuzzlePiece,
  [MDSIconKind.GoogleChrome]: ProRegularSvgIcons.faBrowser,
  [MDSIconKind.CaretRight]: ProSolidSvgIcons.faCaretRight,
  [MDSIconKind.CaretDown]: ProSolidSvgIcons.faCaretDown,
  [MDSIconKind.CaretUp]: ProSolidSvgIcons.faCaretUp,
  [MDSIconKind.Brand]: ProRegularSvgIcons.faArrowUp,
  [MDSIconKind.BrandHover]: ProRegularSvgIcons.faArrowUp,
  [MDSIconKind.BrandTransparent]: ProRegularSvgIcons.faArrowUp,
  [MDSIconKind.Logo]: ProRegularSvgIcons.faArrowUp,
  [MDSIconKind.ArrowBrand]: ProRegularSvgIcons.faArrowUp,
  [MDSIconKind.AutoOrganize]: ProRegularSvgIcons.faSparkles,
  [MDSIconKind.Find]: ProRegularSvgIcons.faSearch,
  [MDSIconKind.GoogleCalendar]: ProRegularSvgIcons.faCalendar,
  [MDSIconKind.OutlookCalendar]: ProRegularSvgIcons.faCalendar,
};

export const customIconMapping: Partial<
  Record<MDSIconKind, ComponentType<React.SVGProps<SVGSVGElement>>>
> = {
  [MDSIconKind.CloudSlashFlipped]: CloudSlashFlippedIcon,
  [MDSIconKind.CodeBlock]: CodeBlockIcon,
  [MDSIconKind.LogoZapier]: ZapierLogoIcon,
  [MDSIconKind.LogoZapierSquare]: ZapierLogoSquareIcon,
  [MDSIconKind.LogoFireflies]: FirefliesLogoIcon,
  [MDSIconKind.LogoTypeform]: TypeformLogoIcon,
  [MDSIconKind.SkipForward]: SkipForwardIcon,
  [MDSIconKind.SkipBackward]: SkipBackwardIcon,
  [MDSIconKind.Cleanup]: CleanupIcon,
  [MDSIconKind.GoogleChrome]: GoogleChromeIcon,
  [MDSIconKind.Microphone]: VoiceModeIcon,
  [MDSIconKind.AutoOrganize]: AutoOrganizeIcon,
  [MDSIconKind.Brand]: BrandIcon,
  [MDSIconKind.BrandHover]: BrandHoverIcon,
  [MDSIconKind.BrandTransparent]: BrandDisabledIcon,
  [MDSIconKind.Logo]: LogoIcon,
  [MDSIconKind.ArrowBrand]: ArrowBrandIcon,
  [MDSIconKind.Find]: FindIcon,
  [MDSIconKind.Radar]: RadarIcon,
  [MDSIconKind.GoogleCalendar]: GoogleCalendarIcon,
  [MDSIconKind.OutlookCalendar]: OutlookCalendarIcon,
};
